export function clientRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_CLIENT_START":           
        case "UPDATE_CLIENT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_CLIENT_FULFILLED":           
        case "UPDATE_CLIENT_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_CLIENT_ERROR":
        case "UPDATE_CLIENT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}